<template>
    <div class="edit-payout-step-initial">
        <SetDetails :mode="mode" :set="set" />
        <div class="step-content">
            <div class="payout">
                <p class="label">Artist Fee:</p>
                <input
                    placeholder="$100"
                    v-model="data.budget"
                    @input="canValidate = true"
                    class="payout-input"
                    type="number"
                    min="1"
                />
                <p class="payout-language">{{ payoutLanguage }}</p>
            </div>
        </div>
        <div class="error-messages">
            <div class="payout-error">
                <span v-if="canValidate && hasError" class="error-message">
                    {{ errorMessage }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    import editSetCmpntAndProps from '@/mixins/edit-set'

    export default {
        name: 'EditPayoutStepInitial',
        emits: ['update:editData', 'has-error'],
        mixins: [editSetCmpntAndProps],
        data: () => ({
            canValidate: false,
            errorMessage: '',
            data: {}
        }),
        created() {
            this.data = this.editData
        },
        computed: {
            hasError: (self) => {
                if (!self.data.budget) {
                    self.errorMessage = 'Set payout is required.'
                    return true
                }
                if (parseInt(self.data.budget) < 1) {
                    self.errorMessage = 'Set payout must be greater than 1 dollar.'
                    return true
                }

                return false
            },
            payoutLanguage: (self) => {
                if (!self.data.budget) {
                    return ''
                }

                const budget = parseFloat(self.data.budget)
                const venueFee = parseFloat(self.set.venueFee)

                const totalPay = (budget * (1 + venueFee)).toFixed(2)
                const hedlynerFee = (totalPay - budget).toFixed(2)

                return `Hedlyner Fees: $${hedlynerFee}, You Pay: $${totalPay}`
            }
        },
        watch: {
            data: {
                handler: function (val) {
                    this.$emit('update:editData', val)
                },
                deep: true,
                immediate: true
            },
            hasError(val) {
                this.$emit('has-error', val)
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }

    .edit-payout-step-initial {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 40px;

        .step-content {
            align-self: flex-start;
            width: 100%;
            max-width: 308px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            gap: 16px;

            .payout {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 6px;

                .label {
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
                .payout-input {
                    max-width: 146px;
                    height: 47px;
                    padding: 12px 15px 15px 15px;
                    color: #dedede;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                    background: inherit;
                    border-radius: 12px;
                    border: 1px solid #8b8b8b;
                }
                .payout-input::placeholder {
                    color: #646464;
                    font-family: 'Instrument Sans';
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 125%;
                }
                .payout-language {
                    margin-top: 2px;
                    color: #acacac;
                    font-family: 'Instrument Sans';
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
            }
        }
        .error-messages {
            width: 100%;
            position: absolute;
            bottom: -20px;

            .error-message {
                color: #ed3c0d;
                font-family: Instrument Sans;
                font-size: 10px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%;
                letter-spacing: 0.14px;
            }
        }
    }
</style>
